import { get } from 'lodash-es';
import { h } from './p-06a8959f.js';
import { B as BxfTypeAheadConstants } from './p-83ac037f.js';

class BxfTypeAheadUiUtil {
    //#region "Highlight Option"
    static getMatchContent(option, highlightMode) {
        let beforeMatch, match, afterMatch;
        if (highlightMode === 'suggested') {
            beforeMatch = get(option, 'displayValue', '').substring(0, get(option, 'bxfMatch.endIndex', get(option, 'displayValue', '').length));
            match = get(option, 'displayValue', '').substring(get(option, 'bxfMatch.endIndex', 0), get(option, 'bxfMatch')
                ? get(option, 'displayValue', '').length
                : 0);
            afterMatch = '';
        }
        else {
            beforeMatch = get(option, 'displayValue', '').substring(0, get(option, 'bxfMatch.startIndex', 0));
            match = get(option, 'displayValue', '').substring(get(option, 'bxfMatch.startIndex', 0), get(option, 'bxfMatch.endIndex', 0));
            afterMatch = get(option, 'displayValue', '').substring(get(option, 'bxfMatch.endIndex', 0));
        }
        return { beforeMatch, match, afterMatch };
    }
    static highlightDynamicOption(option) {
        return (h("div", { title: get(option, 'displayValue', ''), class: BxfTypeAheadConstants.STRING.OPTION_HIGHLIGHT_CONTAINER }, get(option, 'displayValue', '')
            .split('')
            .map((character, characterIndex) => (h("span", { class: {
                [BxfTypeAheadConstants.STRING.OPTION_HIGHLIGHT]: option.bxfMatch.dynamic.includes(characterIndex),
            } }, character)))));
    }
    static hightlightOption(option, highlightMode) {
        if (get(option, 'bxfMatch.dynamic')) {
            return this.highlightDynamicOption(option);
        }
        const { beforeMatch, match, afterMatch } = BxfTypeAheadUiUtil.getMatchContent(option, highlightMode);
        return (h("div", { title: get(option, 'tooltip', '') ||
                get(option, 'displayValue', ''), class: BxfTypeAheadConstants.STRING.OPTION_HIGHLIGHT_CONTAINER },
            h("span", null, beforeMatch),
            h("mark", { class: BxfTypeAheadConstants.STRING.OPTION_HIGHLIGHT }, match),
            h("span", null, afterMatch)));
    }
    //#endregion "Highlight Option"
    //#region "Data for table"
    static getKeyColumn(data = []) {
        return data.find((optionGroup) => optionGroup.isKey) || data[0];
    }
    static getKeyColumnIndex(data = []) {
        const index = data.findIndex((optionGroup) => optionGroup.isKey);
        return index > -1 ? index : 0;
    }
    static getTableRows(data = []) {
        const rows = [];
        for (let numberOfRows = 0; numberOfRows < (data[0] || []).values.length; numberOfRows++) {
            const row = [];
            data.forEach((optionGroup) => {
                row.push(optionGroup.values[numberOfRows] || {});
            });
            rows.push(row);
        }
        return rows;
    }
}

export { BxfTypeAheadUiUtil as B };
